
import { defineComponent } from 'vue';
import { Icon } from '@iconify/vue';

export default defineComponent({
  name: 'CheckoutFreightOptions',
  components: { Icon },
  emits: ['select'],
  props: {
    options: { type: Array, required: true },
    selectedFreight: { type: String, required: true },
    loading: { type: String, required: true },
  },
  methods: {
    normalizeValue(value: number | string) {
      return typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
    },
    formatCurrency(value: number | string) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(Number(value) || 0);
    },
  },
});
